import { ReduxState } from '../../../../../../redux';

export const selectUserData = (state: ReduxState) => state.user.userData;
export const selectUserId = (state: ReduxState) => state.user.userData?.data?.userId;
export const selectUserAttributes = (state: ReduxState) => state.user.userAttributes;
